import { Link } from 'react-router-dom';

const stats = [
  { value: '2 大频道', label: '电视剧 / 电影', icon: 'ri-layout-grid-line' },
  { value: '多维筛选', label: '类型 · 地区 · 年份', icon: 'ri-filter-3-line' },
  { value: '纯净浏览', label: '无播放 / 无下载', icon: 'ri-file-list-3-line' },
];

export default function SiteIntro() {
  return (
    <section className="px-4 md:px-8 py-12 md:py-16 bg-primary-950 text-background-50">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <div>
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs bg-background-50/10 border border-background-50/20 text-accent-400">
            <i className="ri-film-line" aria-hidden="true"></i>
            关于年轻的岳母
          </span>
          <h2 className="mt-5 font-heading text-2xl md:text-3xl font-bold leading-snug">
            专注高清影视的资料展示平台
          </h2>
          <p className="mt-4 text-sm md:text-base text-background-200 leading-relaxed">
            年轻的岳母致力于为影视爱好者提供清晰、专业的内容浏览体验。我们汇集丰富的电视剧与电影资料，涵盖各种题材与热门作品，帮助你在追剧之前，先了解完整的剧情脉络与演员阵容。
          </p>
          <p className="mt-3 text-sm md:text-base text-background-200 leading-relaxed">
            你可以按类型、地区、年份进行多维度筛选，也能通过关键词快速定位感兴趣的作品，并查看详细的剧情简介与演职人员信息。
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link
              to="/category/tv"
              className="inline-flex items-center gap-2 px-6 h-11 rounded-md bg-accent-500 text-secondary-950 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              浏览电视剧
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 h-11 rounded-md border border-background-50/25 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解我们
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-1 gap-4">
          {stats.map((s) => (
            <div
              key={s.value}
              className="flex items-center gap-4 p-5 rounded-lg bg-background-50/5 border border-background-50/10"
            >
              <span className="w-12 h-12 shrink-0 rounded-lg bg-accent-500/15 text-accent-400 flex items-center justify-center text-2xl">
                <i className={s.icon} aria-hidden="true"></i>
              </span>
              <div>
                <p className="font-heading text-lg font-bold text-background-50">{s.value}</p>
                <p className="mt-0.5 text-xs text-background-300">{s.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}